import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {Owner} from "../../model/customer/owner";
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearCustomerBackUrl} from "../config/crystalclear-customer-back-url";
import {CustomerLimits} from "../../model/customer/customer-limits";

@Injectable({
  providedIn: 'root'
})
export class CustomerCustomerLimitsService extends CommonCrudService<CustomerLimits> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_CUSTOMER_LIMITS_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_CUSTOMER_LIMITS,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_CUSTOMER_LIMITS);
  }

}
